import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  ItineraryInterface,
  ItinerariesTypes,
  ResumeItineraryInterface,
  ItineraryResumeTripCapacityList,
  StopDeparturesInterface,
  VehicleLicenseInterface,
  TokenInterface,
  UserTrasactionInterface,
  BpeListInterface,
} from './types';

// List Itineraries
export const listItinerariesRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(ItinerariesTypes.LIST_ITINERARIES_REQUEST, payload);
export const listItinerariesSuccess = (payload: {
  itinerariesList: ItineraryInterface;
  totalCount: number;
}) => action(ItinerariesTypes.LIST_ITINERARIES_SUCCESS, payload);
export const listItinerariesFailure = () =>
  action(ItinerariesTypes.LIST_ITINERARIES_FAILURE);

export const listItinerariesByWeekdaysRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_REQUEST, payload);
export const listItinerariesByWeekdaysSuccess = (payload: {
  itinerariesByWeekdaysList: any;
}) => action(ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_SUCCESS, payload);
export const listItinerariesByWeekdaysFailure = () =>
  action(ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_FAILURE);

// Filter Itineraries
export const filterItinerariesRequest = (payload: object) =>
  action(ItinerariesTypes.FILTER_ITINERARIES_REQUEST, payload);
export const filterItinerariesSuccess = (payload: {
  itinerariesList: ItineraryInterface;
  totalCount: number;
}) => action(ItinerariesTypes.FILTER_ITINERARIES_SUCCESS, payload);
export const filterItinerariesFailure = () =>
  action(ItinerariesTypes.FILTER_ITINERARIES_FAILURE);

// Get Itinerary
export const getItineraryRequest = (payload: object) =>
  asyncAction(ItinerariesTypes.GET_ITINERARY_REQUEST, payload);
export const getItinerarySuccess = (payload: {
  itineraryData: ItineraryInterface;
}) => action(ItinerariesTypes.GET_ITINERARY_SUCCESS, payload);
export const getItineraryFailure = () =>
  action(ItinerariesTypes.GET_ITINERARY_FAILURE);

// Create Itinerary
export const createItineraryRequest = (payload: object) =>
  action(ItinerariesTypes.CREATE_ITINERARY_REQUEST, payload);
export const createItinerarySuccess = (payload: {
  itineraryData: ItineraryInterface;
}) => action(ItinerariesTypes.CREATE_ITINERARY_SUCCESS, payload);
export const createItineraryFailure = () =>
  action(ItinerariesTypes.CREATE_ITINERARY_FAILURE);

// Update Itinerary
export const updateItineraryRequest = (payload: object) =>
  action(ItinerariesTypes.UPDATE_ITINERARY_REQUEST, payload);
export const updateItinerarySuccess = (payload: {
  itineraryData: ItineraryInterface;
}) => action(ItinerariesTypes.UPDATE_ITINERARY_SUCCESS, payload);
export const updateItineraryFailure = () =>
  action(ItinerariesTypes.UPDATE_ITINERARY_FAILURE);

// Delete Itinerary
export const deleteItineraryRequest = (payload: object) =>
  action(ItinerariesTypes.DELETE_ITINERARY_REQUEST, payload);
export const deleteItinerarySuccess = () =>
  action(ItinerariesTypes.DELETE_ITINERARY_SUCCESS);
export const deleteItineraryFailure = () =>
  action(ItinerariesTypes.DELETE_ITINERARY_FAILURE);

// Resume Itinerary
export const resumeItineraryRequest = (payload: {
  showLoading?: boolean;
  isSecondOpem?: boolean;
  body: object;
}) => action(ItinerariesTypes.RESUME_ITINERARY_REQUEST, payload);
export const resumeItinerarySuccess = (payload: {
  itineraryResumeList: ResumeItineraryInterface;
}) => action(ItinerariesTypes.RESUME_ITINERARY_SUCCESS, payload);
export const resumeItineraryFailure = () =>
  action(ItinerariesTypes.RESUME_ITINERARY_FAILURE);

// Current Line to Resume
export const setCurrentLine = (payload: { currentLine: object }) =>
  action(ItinerariesTypes.SET_CURRENT_LINE, payload);

// Resume Itinerary Trip Capacity
export const resumeItineraryTripCapacityRequest = (payload: object) =>
  action(ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_REQUEST, payload);
export const resumeItineraryTripCapacitySuccess = (payload: {
  itineraryResumeTripCapacityList: ItineraryResumeTripCapacityList[];
}) => action(ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_SUCCESS, payload);
export const resumeItineraryTripCapacityFailure = () =>
  action(ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_FAILURE);

// Stop Departures
export const stopDeparturesRequest = (payload: { body: object }) =>
  action(ItinerariesTypes.STOP_DEPARTURES_REQUEST, payload);
export const stopDeparturesSuccess = (payload: {
  stopDepartures: StopDeparturesInterface;
}) => action(ItinerariesTypes.STOP_DEPARTURES_SUCCESS, payload);
export const stopDeparturesFailure = () =>
  action(ItinerariesTypes.STOP_DEPARTURES_FAILURE);

// Pedestrian Tokens
export const pedestrianTokensRequest = (payload: { body: object }) =>
  asyncAction(ItinerariesTypes.PEDESTRIAN_TOKENS_REQUEST, payload);
export const pedestrianTokensSuccess = () =>
  action(ItinerariesTypes.PEDESTRIAN_TOKENS_SUCCESS);
export const pedestrianTokensFailure = () =>
  action(ItinerariesTypes.PEDESTRIAN_TOKENS_FAILURE);

// Vehicle Tokens
export const vehicleTokensRequest = (payload: { body: object }) =>
  asyncAction(ItinerariesTypes.VEHICLE_TOKENS_REQUEST, payload);
export const vehicleTokensSuccess = () =>
  action(ItinerariesTypes.VEHICLE_TOKENS_SUCCESS);
export const vehicleTokensFailure = () =>
  action(ItinerariesTypes.VEHICLE_TOKENS_FAILURE);

// Reschedule Token
export const rescheduleTokenRequest = (payload: { body: object }) =>
  asyncAction(ItinerariesTypes.RESCHEDULE_TOKEN_REQUEST, payload);
export const rescheduleTokenSuccess = () =>
  action(ItinerariesTypes.RESCHEDULE_TOKEN_SUCCESS);
export const rescheduleTokenFailure = () =>
  action(ItinerariesTypes.RESCHEDULE_TOKEN_FAILURE);

// Seat Pre Reserve
export const seatPreReserveRequest = (payload: {
  tripScheduleSeatId: string;
  transportOperatorId?: string;
}) => asyncAction(ItinerariesTypes.SEAT_PRE_RESERVE_REQUEST, payload);
export const seatPreReserveSuccess = () =>
  action(ItinerariesTypes.SEAT_PRE_RESERVE_SUCCESS);
export const seatPreReserveFailure = () =>
  action(ItinerariesTypes.SEAT_PRE_RESERVE_FAILURE);

// Filter Vehicle License
export const filterVehicleLicenseRequest = (payload: object) =>
  action(ItinerariesTypes.FILTER_VEHIVLE_LICENSE_REQUEST, payload);
export const filterVehicleLicenseSuccess = (payload: {
  vehicleLicense: VehicleLicenseInterface;
  license: string;
}) => action(ItinerariesTypes.FILTER_VEHIVLE_LICENSE_SUCCESS, payload);
export const filterVehicleLicenseFailure = () =>
  action(ItinerariesTypes.FILTER_VEHIVLE_LICENSE_FAILURE);

// Tokens List
export const tokenListRequest = (payload: { body: object }) =>
  action(ItinerariesTypes.TOKEN_LIST_REQUEST, payload);
export const tokenListSuccess = (payload: { tokenList: TokenInterface }) =>
  action(ItinerariesTypes.TOKEN_LIST_SUCCESS, payload);
export const tokenListFailure = () =>
  action(ItinerariesTypes.TOKEN_LIST_FAILURE);

// Tokens List
export const userTransactionListRequest = (payload: { body: object }) =>
  action(ItinerariesTypes.USER_TRASACTION_LIST_REQUEST, payload);
export const userTransactionListSuccess = (payload: {
  userTransactionList: UserTrasactionInterface;
}) => action(ItinerariesTypes.USER_TRASACTION_LIST_SUCCESS, payload);
export const userTransactionListFailure = () =>
  action(ItinerariesTypes.USER_TRASACTION_LIST_FAILURE);

export const cancelBookedTokenRequest = (payload: { body: object }) =>
  action(ItinerariesTypes.CANCEL_BOOKED_TOKEN_REQUEST, payload);
export const cancelBookedTokenSuccess = () =>
  action(ItinerariesTypes.CANCEL_BOOKED_TOKEN_SUCCESS);
export const cancelBookedTokenFailure = () =>
  action(ItinerariesTypes.CANCEL_BOOKED_TOKEN_FAILURE);

// Bpe List
export const bpeListRequest = (payload: { body: object }) =>
  action(ItinerariesTypes.BPE_LIST_REQUEST, payload);
export const bpeListSuccess = (payload: { bpeList: BpeListInterface[] }) =>
  action(ItinerariesTypes.BPE_LIST_SUCCESS, payload);
export const bpeListFailure = () => action(ItinerariesTypes.BPE_LIST_FAILURE);

// Get BPE PDF
export const getBpePdfRequest = (payload: { body: object }) =>
  asyncAction(ItinerariesTypes.GET_BPE_PDF_REQUEST, payload);
export const getBpePdfSuccess = () =>
  action(ItinerariesTypes.GET_BPE_PDF_SUCCESS);
export const getBpePdfFailure = () =>
  action(ItinerariesTypes.GET_BPE_PDF_FAILURE);

// Tokens List
export const get3DsTokenRequest = (payload: object) =>
  action(ItinerariesTypes.GET_3DS_TOKEN_REQUEST, payload);
export const get3DsTokenSuccess = (payload: object) =>
  action(ItinerariesTypes.GET_3DS_TOKEN_SUCCESS, payload);
export const get3DsTokenFailure = () =>
  action(ItinerariesTypes.GET_3DS_TOKEN_FAILURE);
